import { mapModes } from 'client/utils/constants/appStates';
import { DESKTOP, MOBILE, TABLET } from 'client/utils/constants/GDS/js/devices';

const { DEFAULT, DRAWING, MODIFYING, AOI, LOADING, ADDING_OBSERVATION } = mapModes;

export const DEVICE_VALID_MODES = {
    [MOBILE]: [
        [DEFAULT],
        [DEFAULT, DRAWING],
        [DEFAULT, LOADING],
        [DEFAULT, LOADING, AOI],
        [DEFAULT, AOI],
        [DEFAULT, AOI, ADDING_OBSERVATION],
        [LOADING, DEFAULT],
        [LOADING, DEFAULT, AOI]
    ],
    [TABLET]: [
        [DEFAULT],
        [DEFAULT, DRAWING],
        [DEFAULT, LOADING],
        [DEFAULT, LOADING, AOI],
        [DEFAULT, AOI],
        [DEFAULT, AOI, ADDING_OBSERVATION],
        [LOADING, DEFAULT],
        [LOADING, DEFAULT, AOI]
    ],
    [DESKTOP]: [
        [DEFAULT],
        [DEFAULT, DRAWING],
        [DEFAULT, LOADING],
        [DEFAULT, LOADING, AOI],
        [DEFAULT, AOI],
        [DEFAULT, AOI, ADDING_OBSERVATION],
        [AOI, MODIFYING],
        [AOI, MODIFYING, DRAWING],
        [LOADING, DEFAULT],
        [LOADING, DEFAULT, AOI]
    ]
};
